import { Routes, Route, useNavigate } from 'react-router-dom'
import Tour from './Tour'
import { useEffect, useState } from 'react'
import Viewer from './Viewer'

function Landing() {
  const navigate = useNavigate()

  const startTour = (id) => {
    navigate('/tour', { state: { id } })
  }


  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    console.log(window.innerWidth);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  function setResponsiveSize(desktopScreen, tabletScreen, mobileScreen) {
    if (windowWidth > 1500) return desktopScreen; // desktop screen (1366, 1536, 1920)
    if (windowWidth > 1000) return tabletScreen; // tablet screen (1080, 1180, 1024)
    return mobileScreen; // mobile screen (800, 844, 873)
  }

  const livingRoomButton = {
    // top: setResponsiveSize('400px', '40%', '40%'),
    // left: setResponsiveSize('1050px', '52%', '52%'),
    // height: setResponsiveSize('250px', '30%', '30%'),
    // width: setResponsiveSize('700px', '40%', '40%'),
    top:'40%',
    left: '52%', 
    height: '30%',
    width: '40%'
  };

  const masterBedroomButton = {
    top:'20%', 
    left:'20%', 
    height:'20%', 
    width:'26%'
  };

  const kitchenButton = {
    top: '45%', 
    left: '30%', 
    height: '20%', 
    width: '13%' 
  };
  
  const floor2Room1Button = {
    top: '20%', 
    left: '66%', 
    height: '19%', 
    width: '15%', 
  };

  const viewerButton = {
    top: '92%',
    right: '5%',
    height: '5%', 
    width: '5%', 
    backgroundColor: "rgba(0, 247, 255, 0.568)",
  }

  const viewerText = {
    fontSize: "0.8vw",
    color: "black"
  }

  return (
    <>
      <div
        className='container'>
        <img
          src="assets/house.jpg"
          alt="Wide image"
          className='house-bg'
        ></img>
        <div className='square-container'>
          <div className='square' onClick={() => startTour('F1LR')} style={livingRoomButton}>
            <span>LIVING ROOM</span>
          </div>
          <div className='square' onClick={() => startTour('F2R2')} style={masterBedroomButton}>
            <span>master bedroom</span>
          </div>
          <div className='square' onClick={() => startTour('F1K')} style={kitchenButton}>
            <span>kitchen</span>
          </div>
          <div className='square' onClick={() => startTour('F2R1')} style={floor2Room1Button}>
            <span>floor 2 room 1</span>
          </div>
          <div className='square' onClick={() => { navigate('/viewer') }} style={viewerButton}>
            <span style={viewerText}>Viewer</span>
          </div>
        </div>
      </div>
    </>
  )
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/tour" element={
					<Tour />
				} />
      <Route path="/viewer" element={<Viewer />} />
    </Routes>
  )
}
